import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const ExternalLink = styled(Box)(({ theme }) => ({
  color: theme.palette.primary.main,
  textDecoration: 'none',
  cursor: 'pointer',
  '&:hover': {
    textDecoration: 'underline',
  },
}));
